import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import capitalize from 'lodash/capitalize';
import { Box, Text, Icon } from 'roo-ui/components';
import PayWith from 'components/Filters/Search/PayWith';
import PillButton from 'components/PillButton';
import { useDataLayer } from 'hooks/useDataLayer';
import Modal, { ModalFooter } from 'components/Modal';
import { useModal } from 'lib/hooks';
import { useSelector } from 'react-redux';
import { getQueryPayWith } from 'store/search/searchSelectors';

const PayWithSelector = ({ onChange }) => {
  const { emitInteractionEvent } = useDataLayer();
  const { openModal, closeModal, modalProps } = useModal();
  const payWith = useSelector(getQueryPayWith);

  const onOpenModal = useCallback(() => {
    openModal();
    emitInteractionEvent({ type: 'Mobile Filters Buttons', value: `Payment Options Selected` });
  }, [openModal, emitInteractionEvent]);

  const onCloseModal = useCallback(() => {
    closeModal();
    emitInteractionEvent({ type: `Mobile Filters Payment Options`, value: 'Close Modal Selected' });
  }, [closeModal, emitInteractionEvent]);

  const onSubmitModal = useCallback(() => {
    closeModal();
    emitInteractionEvent({ type: `Mobile Filters Payment Options`, value: 'View Results Selected' });
  }, [closeModal, emitInteractionEvent]);

  const onPayWithChanged = useCallback(
    (newQuery) => {
      onChange(newQuery);
      emitInteractionEvent({ type: 'Mobile Filters Payment Options', value: `Use ${capitalize(newQuery.payWith)} Selected` });
    },
    [emitInteractionEvent, onChange],
  );

  return (
    <Fragment>
      <PillButton onClick={onOpenModal}>
        <Text fontSize="xs">Use {payWith}</Text>
        <Icon name="expandMore" size={20} />
      </PillButton>
      {modalProps.isOpen && (
        <Modal
          {...modalProps}
          onRequestClose={onCloseModal}
          title="Payment Options"
          padding={0}
          footerComponent={() => <ModalFooter submitModal={onSubmitModal} buttonText="View results" />}
        >
          <Box padding={4} bg="greys.porcelain" height="100%">
            <PayWith payWith={payWith} onChange={onPayWithChanged} hideClear={true} />
          </Box>
        </Modal>
      )}
    </Fragment>
  );
};

PayWithSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default PayWithSelector;
